import {Component, Input, Output, EventEmitter, OnInit} from "@angular/core";

@Component({
  selector: 'widget-textarea',
  template: `<div
                [formGroup]="form"
                [class.has-error]="form.controls[id].touched && !form.controls[id].valid"
                [class.has-feedback]="form.controls[id].touched && !form.controls[id].valid">
                <label class="control-label {{labelClass}}" for="{{id}}" [class.active]="model">{{ txtLabel | translate }}</label>
                <div class="{{containerInputClass}}">

                  <textarea rows="3" cols="5" class="form-control validate" id="{{id}}" placeholder="{{placeholder}}"
                          [(ngModel)]="model"
                          formControlName="{{id}}"
                          [class.input-view]="readonly"
                          [readonly]="readonly"
                          [style.height.px]="height"
                          [tipoTexto]="tipoTexto"
                          (change)="update($event.target.value)"
                          (keypress)="update($event.target.value)"
                          (keyup)="update($event.target.value)"
                          (keydown)="update($event.target.value)"
                          (blur)="update($event.target.value)"></textarea>
                  
                  
                  
                  <div class="form-control-feedback" *ngIf="form.controls[id].touched && !form.controls[id].valid">
                    <i class="icon-cancel-circle2"></i>
                  </div>
                  <ng-template [ngIf]="form.controls[id].errors">
                    <span class="help-block" *ngIf="form.controls[id].touched && !form.controls[id].valid && !form.controls[id].errors[id]">{{txt_default_erro}}</span>
                    <div *ngIf="!form.controls[id].valid">
                      <span class="help-block" *ngFor="let erro of form.controls[id].errors[id] | keysBack">{{ 'back.'+erro.key | translate:erro.replace }}</span>
                    </div>
                  </ng-template>
                </div>
              </div>`,
})

export class WidgetTextareaComponent implements OnInit {

  @Input()
  id: string = '';

  @Input()
  model: any = '';

  @Output() modelChange = new EventEmitter<string>();

  @Input()
  form: any;

  @Input()
  txt_default_erro: any;

  @Input()
  txtLabel: string = '';

  @Input()
  labelClass: string = 'col-sm-2';

  @Input()
  containerInputClass: string = 'col-sm-10';

  @Input()
  readonly: boolean = false;

  @Input()
  upperCase: boolean = false;

  @Input()
  lowerCase: boolean = false;

  tipoTexto: string;

  @Input()
  placeholder: string = '';

  @Input()
  height: number = 32;

  constructor() {}

  ngOnInit(): void {
    if(!/text-left/g.test(this.labelClass) && !/text-center/g.test(this.labelClass)){
      this.labelClass = this.labelClass+' text-right';
    }
    if(this.upperCase){
      this.tipoTexto = 'upperCase';
    }
    if(this.lowerCase){
      this.tipoTexto = 'lowerCase';
    }
  }

  update(val : string) {
    if(this.upperCase){
      val = val.toUpperCase();
    }
    if(this.lowerCase){
      val = val.toLowerCase();
    }
    this.model = val;
    this.modelChange.emit(this.model);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/form/widget-text.component.ts